export const autoCompleteOptions = {
  componentRestrictions: {
    country: 'USA'
  },
  fields: ['formatted_address'],
  types: ['address']
};
